(function() {
  var KEY = 'cw_selected_size';
  var saving = false;

  function save(size) {
    try { localStorage.setItem(KEY, size); } catch(e) {}
  }

  function load() {
    try { return localStorage.getItem(KEY); } catch(e) { return null; }
  }

  function apply(size) {
    if (!size) return false;
    var btns = document.querySelectorAll('[data-option-value]');
    var applied = false;
    btns.forEach(function(btn) {
      if (btn.getAttribute('data-option-value') === size && btn.getAttribute('data-option-value').length <= 5) {
        btn.click();
        applied = true;
      }
    });
    return applied;
  }

  // Salva via radio nativo (mais confiável que o clique no Pwzr)
  document.addEventListener('change', function(e) {
    if (e.target.type === 'radio' && /tamanho|size/i.test(e.target.name)) {
      save(e.target.value);
    }
  });

  // Fallback: salva via clique no botão Pwzr
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-option-value]');
    if (!btn) return;
    var val = btn.getAttribute('data-option-value');
    if (val && val.length <= 5) save(val);
  });

  // Aplica ao carregar
  window.addEventListener('load', function() {
    var size = load();
    if (!size) return;
    if (apply(size)) return;
    var attempts = 0;
    var timer = setInterval(function() {
      attempts++;
      if (apply(size) || attempts >= 10) clearInterval(timer);
    }, 100);
  });
})();
